(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["at-footer"]) return;
  try {
    
  (()=>{
    const viewport=matchMedia('(max-width:749px)');
    const initialize=(root=document)=>root.querySelectorAll('[data-vh-footer-links]').forEach(details=>{
      if(details.dataset.footerInitialized)return;
      details.dataset.footerInitialized='true';
      details.open=!viewport.matches;
    });
    initialize();
    viewport.addEventListener('change',()=>document.querySelectorAll('[data-vh-footer-links]').forEach(details=>{details.open=!viewport.matches}));
    document.addEventListener('shopify:section:load',event=>initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["at-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const connections = new Map();
    const connectRatings = () => {
      for (const [badge, observer] of connections) {
        if (!badge.isConnected) {
          observer.disconnect();
          connections.delete(badge);
        }
      }
      document.querySelectorAll('[data-ac-rating]').forEach((badge) => {
        if (connections.has(badge)) return;
        const productId = badge.dataset.productId;
        const label = badge.dataset.acRatingLabel;
        const markup = badge.querySelector('.areviews_header_stars');
        let signature = '';
        let target;
        const sync = () => {
          target = [...document.querySelectorAll('.az_reviews')].find((root) =>
            (root.dataset.product_id || root.dataset.productId) === productId);
          const source = target?.querySelector('.Products_reviews[data-areviews-count]');
          if (!source || Number(source.dataset.areviewsCount) < 1) return;
          const next = source.innerHTML;
          if (signature === next) return;
          signature = next;
          markup.replaceChildren(...[...source.childNodes].map((node) => node.cloneNode(true)));
          markup.dataset.areviewsAverage = source.dataset.areviewsAverage;
          markup.dataset.areviewsCount = source.dataset.areviewsCount;
          markup.dataset.areviewsRenderSource = 'app';
          markup.querySelectorAll('a,button,input,[tabindex]').forEach((element) => element.setAttribute('tabindex', '-1'));
          const summary = source.querySelector('.header_reviews_number')?.textContent.trim();
          badge.setAttribute('aria-label', summary ? `${summary}. ${label}` : label);
          badge.hidden = false;
        };
        const openReviews = (event) => {
          if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
          if (!target) return;
          event.preventDefault();
          event.stopPropagation();
          target.setAttribute('tabindex', '-1');
          target.focus({preventScroll:true});
          target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
        };
        badge.addEventListener('click', openReviews);
        badge.addEventListener('keydown', openReviews);
        const observer = new MutationObserver(sync);
        observer.observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true});
        connections.set(badge, observer);
        sync();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connectRatings, {once:true});
    else connectRatings();
    document.addEventListener('shopify:section:load', connectRatings);
    document.addEventListener('shopify:section:unload', connectRatings);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vh-announcement')) {
    customElements.define('vh-announcement', class extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.editorTest = this.dataset.countdownMode === 'preview_visit' && this.dataset.editorTest === 'true' && window.Shopify?.designMode === true;
        if (this.dataset.countdownMode !== 'fixed' && !this.editorTest) return;
        this.hidden = true;
        this.deadline = this.editorTest ? Date.now() + 2 * 60 * 60 * 1000 : this.parseDeadline(this.dataset.deadline || '');
        this.parts = ['hours', 'minutes', 'seconds'].map(part => this.querySelector(`[data-${part}]`));
        if (!Number.isFinite(this.deadline) || this.parts.some(part => !part)) return;
        this.refresh = () => this.updateCountdown();
        this.pageShow = event => {
          if (this.editorTest && event.persisted) this.deadline = Date.now() + 2 * 60 * 60 * 1000;
          this.updateCountdown();
        };
        document.addEventListener('visibilitychange', this.refresh);
        window.addEventListener('pageshow', this.pageShow);
        this.updateCountdown();
      }

      disconnectedCallback() {
        clearTimeout(this.tick);
        if (this.refresh) {
          document.removeEventListener('visibilitychange', this.refresh);
        }
        if (this.pageShow) window.removeEventListener('pageshow', this.pageShow);
      }

      parseDeadline(value) {
        const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|([+-])(\d{2}):(\d{2}))$/.exec(value);
        if (!match) return NaN;
        const [, year, month, day, hour, minute, second, zone, , zoneHour, zoneMinute] = match;
        const leap = Number(year) % 4 === 0 && (Number(year) % 100 !== 0 || Number(year) % 400 === 0);
        const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (Number(year) < 1 || Number(month) < 1 || Number(month) > 12 || Number(day) < 1 || Number(day) > days[Number(month) - 1]) return NaN;
        if (Number(hour) > 23 || Number(minute) > 59 || Number(second) > 59) return NaN;
        if (zone !== 'Z' && (Number(zoneHour) > 14 || Number(zoneMinute) > 59 || (Number(zoneHour) === 14 && Number(zoneMinute) !== 0))) return NaN;
        return Date.parse(value);
      }

      updateCountdown() {
        clearTimeout(this.tick);
        const milliseconds = this.deadline - Date.now();
        if (milliseconds <= 0) {
          if (this.editorTest) {
            this.parts.forEach(part => { part.textContent = '00'; });
            this.hidden = false;
            return;
          }
          this.hidden = true;
          this.disconnectedCallback();
          return;
        }
        const remaining = Math.ceil(milliseconds / 1000);
        const values = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
        this.parts.forEach((part, index) => { part.textContent = String(values[index]).padStart(2, '0'); });
        this.hidden = false;
        this.tick = setTimeout(() => this.updateCountdown(), Math.min(1000, milliseconds));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-demonstration"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vh-demonstration')) customElements.define('vh-demonstration', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.querySelectorAll('video').forEach(video => {
        const fitVideo = () => {
          if (video.videoWidth > 0 && video.videoHeight > 0) {
            this.style.setProperty('--vh-demo-ratio', String(video.videoWidth / video.videoHeight));
          }
        };
        video.addEventListener('loadedmetadata', fitVideo, { signal: this.abort.signal });
        video.addEventListener('resize', fitVideo, { signal: this.abort.signal });
        if (video.readyState > 0) fitVideo();
        else if (video.preload === 'none') video.preload = 'metadata';
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-footer"]) return;
  try {
    
  (()=>{
    const viewport=matchMedia('(max-width:749px)');
    const initialize=(root=document)=>root.querySelectorAll('[data-vh-footer-links]').forEach(details=>{
      if(details.dataset.footerInitialized)return;
      details.dataset.footerInitialized='true';
      details.open=!viewport.matches;
    });
    initialize();
    viewport.addEventListener('change',()=>document.querySelectorAll('[data-vh-footer-links]').forEach(details=>{details.open=!viewport.matches}));
    document.addEventListener('shopify:section:load',event=>initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-header"]) return;
  try {
    
  (()=>{
    const states=new WeakMap();
    const restore=menu=>{
      const state=states.get(menu);
      if(state)state.forEach(([element,inert])=>{element.inert=inert});
      states.delete(menu);
      const panel=menu.querySelector('.vh-mobile-menu__panel');
      panel?.removeAttribute('role');
      panel?.removeAttribute('aria-modal');
      document.body.classList.toggle('vh-menu-open',Boolean(document.querySelector('[data-vh-mobile-menu][open]')));
    };
    const close=menu=>{menu.open=false;restore(menu);menu.querySelector('summary')?.focus()};
    const position=menu=>{const top=Math.max(0,menu.closest('.vh-header').getBoundingClientRect().top);menu.style.setProperty('--vh-menu-top',`${top}px`)};
    const init=root=>{
      root.querySelectorAll('[data-vh-mobile-menu]').forEach(menu=>{
        if(menu.dataset.menuInitialized)return;
        menu.dataset.menuInitialized='true';
        menu.addEventListener('toggle',()=>{
          if(!menu.open){restore(menu);return}
          document.querySelectorAll('[data-vh-mobile-menu][open]').forEach(other=>{if(other!==menu){other.open=false;restore(other)}});
          position(menu);
          const panel=menu.querySelector('.vh-mobile-menu__panel');
          panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');
          const siblings=Array.from(document.querySelectorAll('#MainContent,.vh-footer,.vh-header__logo,.vh-header__actions,.vh-header__navigation'));
          states.set(menu,siblings.map(element=>[element,element.inert]));
          siblings.forEach(element=>{element.inert=true});
          document.body.classList.add('vh-menu-open');
          panel.querySelector('[data-vh-menu-close]')?.focus({preventScroll:true});
        });
        menu.querySelector('[data-vh-menu-close]')?.addEventListener('click',()=>close(menu));
        menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>close(menu)));
        menu.addEventListener('keydown',event=>{
          if(!menu.open)return;
          if(event.key==='Escape'){event.preventDefault();close(menu);return}
          if(event.key!=='Tab')return;
          const targets=Array.from(menu.querySelectorAll('.vh-mobile-menu__panel button,.vh-mobile-menu__panel a[href]')).filter(element=>element.getClientRects().length);
          const first=targets[0],last=targets[targets.length-1];
          if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus()}
          else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus()}
        });
      });
    };
    init(document);
    document.addEventListener('shopify:section:load',event=>init(event.target));
    document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-vh-mobile-menu]').forEach(restore));
    window.addEventListener('resize',()=>document.querySelectorAll('[data-vh-mobile-menu][open]').forEach(menu=>{if(matchMedia('(min-width:990px)').matches)close(menu);else position(menu)}));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-mechanism"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mechanisms = new Map();
  const update = (element, record) => {
    element.dataset.vhMechanismMotion = record.visible && !record.paused && document.visibilityState !== 'hidden' ? 'active' : 'paused';
  };
  const initialize = (scope = document) => {
    scope.querySelectorAll('.vh-mechanism').forEach((element) => {
      if (mechanisms.has(element)) return;
      const record = { visible: true, paused: false, observer: null, controller: new AbortController() };
      const toggle = element.querySelector('[data-mechanism-pause]');
      toggle?.addEventListener('click', () => {
        record.paused = !record.paused;
        toggle.setAttribute('aria-pressed', String(record.paused));
        toggle.textContent = record.paused ? toggle.dataset.resumeLabel : toggle.dataset.pauseLabel;
        update(element, record);
      }, { signal: record.controller.signal });
      if ('IntersectionObserver' in window) {
        record.visible = false;
        record.observer = new IntersectionObserver((entries) => {
          record.visible = entries.some((entry) => entry.isIntersecting);
          update(element, record);
        }, { threshold: 0.08 });
        record.observer.observe(element);
      }
      mechanisms.set(element, record);
      update(element, record);
    });
  };
  initialize();
  document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  document.addEventListener('visibilitychange', () => mechanisms.forEach((record, element) => update(element, record)));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    mechanisms.forEach((record, element) => {
      if (!event.target.contains(element)) return;
      record.observer?.disconnect();
      record.controller.abort();
      mechanisms.delete(element);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-product"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('vh-gallery-zoom'))customElements.define('vh-gallery-zoom',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.gallery=this.closest('vh-gallery');
      this.dialog=this.querySelector('[data-gallery-dialog]');
      this.links=[...(this.gallery?.querySelectorAll('[data-zoom-image]')||[])];
      if(!this.links.length||typeof this.dialog?.showModal!=='function')return;
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.photo=this.querySelector('[data-zoom-photo]');
      this.previous=this.querySelector('[data-zoom-prev]');
      this.next=this.querySelector('[data-zoom-next]');
      this.status=this.querySelector('[data-zoom-status]');
      this.caption=this.querySelector('[data-zoom-caption]');
      this.loading=this.querySelector('[data-zoom-loading]');
      this.error=this.querySelector('[data-zoom-error]');
      this.original=this.querySelector('[data-zoom-original]');
      this.closeButton=this.querySelector('[data-zoom-close]');
      this.links.forEach((link,index)=>{
        link.setAttribute('role','button');link.setAttribute('aria-haspopup','dialog');
        link.addEventListener('click',event=>{if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||event.button>0)return;if(this.openViewer(index,link)){event.preventDefault();event.stopPropagation()}},options);
        link.addEventListener('keydown',event=>{if(event.key===' '&&this.openViewer(index,link))event.preventDefault()},options);
      });
      this.closeButton.addEventListener('click',()=>this.dialog.close(),options);
      this.previous.addEventListener('click',()=>this.show(this.index-1),options);
      this.next.addEventListener('click',()=>this.show(this.index+1),options);
      this.dialog.addEventListener('cancel',event=>{event.preventDefault();this.dialog.close()},options);
      this.dialog.addEventListener('close',()=>this.cleanup(),options);
      this.dialog.addEventListener('pointerdown',event=>{this.backdropPointer=event.target===this.dialog},options);
      this.dialog.addEventListener('click',event=>{if(this.backdropPointer&&event.target===this.dialog){const rect=this.dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)this.dialog.close()}this.backdropPointer=false},options);
      this.dialog.addEventListener('keydown',event=>{if(!this.dialog.open)return;const direction=event.key==='ArrowRight'?1:event.key==='ArrowLeft'?-1:0;if(direction){event.preventDefault();this.show(this.index+direction)}else if(event.key==='Home'||event.key==='End'){event.preventDefault();this.show(event.key==='Home'?0:this.links.length-1)}},options);
      this.photo.addEventListener('load',()=>{this.loading.hidden=true;this.error.hidden=true},options);
      this.photo.addEventListener('error',()=>{if(!this.dialog.open)return;this.loading.hidden=true;this.error.hidden=false},options);
    }
    openViewer(index,opener){
      if(this.dialog.open)return false;
      try{this.dialog.showModal()}catch{return false}
      this.opener=opener;
      this.show(index);
      this.gallery.querySelectorAll('video').forEach(video=>video.pause());
      this.closeButton.focus({preventScroll:true});
      return true;
    }
    show(index){
      if(!this.dialog.open)return;
      const next=Math.max(0,Math.min(index,this.links.length-1));
      if(next===this.index&&this.photo.getAttribute('src'))return;
      this.index=next;
      const link=this.links[this.index],source=link.getAttribute('href');
      this.loading.hidden=false;this.error.hidden=true;
      this.photo.alt=link.dataset.zoomAlt||'';
      this.caption.textContent=this.photo.alt;
      this.photo.setAttribute('src',source);
      this.original.setAttribute('href',source);
      this.previous.disabled=this.index===0;
      this.next.disabled=this.index===this.links.length-1;
      this.status.textContent=`${this.index+1} / ${this.links.length}`;
    }
    cleanup(){this.photo?.removeAttribute('src');this.original?.removeAttribute('href');this.index=null;if(this.opener?.isConnected)this.opener.focus({preventScroll:true});this.opener=null}
    disconnectedCallback(){if(this.dialog?.open)this.dialog.close();this.cleanup();this.controller?.abort();this.links?.forEach(link=>{link.removeAttribute('role');link.removeAttribute('aria-haspopup')});this.controller=null}
  });
  if(!customElements.get('vh-gallery'))customElements.define('vh-gallery',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.track=this.querySelector('.vh-gallery__track');
      this.slides=[...this.querySelectorAll('.vh-gallery__slide')];
      this.thumbs=[...this.querySelectorAll('[data-gallery-index]')];
      this.progress=this.querySelector('[data-gallery-progress]');
      this.index=Math.max(0,this.slides.findIndex(slide=>slide.dataset.mediaId===this.dataset.initialMedia));
      this.targetIndex=null;
      this.querySelector('.vh-gallery__controls')?.removeAttribute('hidden');
      this.querySelector('.vh-gallery__progress')?.removeAttribute('hidden');
      this.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>this.go(this.index-1),options);
      this.querySelector('[data-gallery-next]')?.addEventListener('click',()=>this.go(this.index+1),options);
      this.progress?.addEventListener('input',()=>this.go(Number(this.progress.value)-1),options);
      this.thumbs.forEach((thumb,index)=>thumb.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();this.go(index)},options));
      this.track.addEventListener('keydown',event=>{if(event.target!==this.track)return;if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();this.go(this.index+(event.key==='ArrowRight'?1:-1))}else if(event.key==='Home'||event.key==='End'){event.preventDefault();this.go(event.key==='Home'?0:this.slides.length-1)}},options);
      const releaseTarget=()=>{this.targetIndex=null};
      this.track.addEventListener('pointerdown',releaseTarget,options);
      this.track.addEventListener('wheel',releaseTarget,{...options,passive:true});
      this.track.addEventListener('scroll',()=>{
        if(this.frame)cancelAnimationFrame(this.frame);
        this.frame=requestAnimationFrame(()=>{
          const observed=this.observedIndex();
          if(this.targetIndex===null){this.index=observed;this.update()}
          else if(Math.abs(this.track.scrollLeft-this.targetIndex*this.track.clientWidth)<1){this.targetIndex=null;this.index=observed;this.update()}
        });
        clearTimeout(this.scrollTimer);
        this.scrollTimer=setTimeout(()=>this.syncScroll(),150);
      },options);
      this.track.addEventListener('scrollend',()=>this.syncScroll(),options);
      this.observer=new ResizeObserver(()=>this.go(this.index,true));
      this.observer.observe(this.track);
      this.go(this.index,true);
    }
    observedIndex(){return Math.max(0,Math.min(this.slides.length-1,Math.round(this.track.scrollLeft/Math.max(1,this.track.clientWidth))))}
    syncScroll(){clearTimeout(this.scrollTimer);this.targetIndex=null;this.index=this.observedIndex();this.update()}
    go(index,instant=false){
      clearTimeout(this.scrollTimer);
      this.index=Math.max(0,Math.min(index,this.slides.length-1));
      const immediate=instant||matchMedia('(prefers-reduced-motion: reduce)').matches;
      const left=this.index*this.track.clientWidth;
      this.targetIndex=immediate||Math.abs(this.track.scrollLeft-left)<1?null:this.index;
      this.track.scrollTo({left,behavior:immediate?'auto':'smooth'});
      this.update();
    }
    selectMedia(id){const index=this.slides.findIndex(slide=>slide.dataset.mediaId===id);if(index>=0)this.go(index)}
    update(){this.thumbs.forEach((thumb,index)=>{if(index===this.index)thumb.setAttribute('aria-current','true');else thumb.removeAttribute('aria-current')});const previous=this.querySelector('[data-gallery-prev]'),next=this.querySelector('[data-gallery-next]'),status=this.querySelector('[data-gallery-status]');if(previous)previous.disabled=this.index===0;if(next)next.disabled=this.index===this.slides.length-1;if(status)status.textContent=`${this.index+1} / ${this.slides.length}`;if(this.progress){this.progress.value=String(this.index+1);this.progress.setAttribute('aria-valuetext',(this.progress.dataset.mediaLabel||'').replace('__number__',String(this.index+1)))}this.slides.forEach((slide,index)=>{if(index!==this.index)slide.querySelectorAll('video').forEach(video=>video.pause())})}
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);clearTimeout(this.scrollTimer);this.targetIndex=null;this.controller=null}
  });
  if(!customElements.get('vh-product'))customElements.define('vh-product',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.addEventListener('change',event=>{
        const input=event.target;
        if((!input.matches('input[name="id"]')&&!input.matches('input[data-bundle-choice]'))||input.disabled)return;
        if(!this.querySelector('[data-fixed-unit-price]')){
          const price=this.querySelector('[data-current-price]');
          if(price)price.textContent=input.dataset.price;
          const saleBadge=this.querySelector('[data-sale-badge]');
          if(saleBadge){saleBadge.textContent=input.dataset.saleLabel||'';saleBadge.hidden=!input.dataset.saleLabel}
          const compare=this.querySelector('[data-compare-price]');
          if(compare){compare.textContent=input.dataset.compare||'';compare.hidden=!input.dataset.compare}
        }
        const button=this.querySelector('[data-add-button]'),enabled=this.dataset.launchEnabled==='true',available=input.dataset.available==='true',preview=input.dataset.preview==='true'||!input.value;
        if(button){button.disabled=!enabled||!available||preview;button.firstChild.textContent=!enabled||preview?button.dataset.pendingLabel:available?button.dataset.addLabel:button.dataset.soldOutLabel}
        const stickyAdd=this.querySelector('[data-sticky-add]');
        if(stickyAdd&&button){stickyAdd.disabled=button.disabled;stickyAdd.textContent=button.firstChild.textContent}
        if(!this.querySelector('[data-fixed-sticky-price]')){
          const stickyPrice=this.querySelector('[data-sticky-price]');
          if(stickyPrice)stickyPrice.textContent=input.dataset.price;
          const stickyCompare=this.querySelector('[data-sticky-compare]');
          if(stickyCompare){stickyCompare.textContent=input.dataset.compare||'';stickyCompare.hidden=!input.dataset.compare}
        }
        const gift=this.querySelector('[data-included-gift]');
        if(gift){gift.value=input.dataset.gift||'';gift.disabled=!input.dataset.gift}
        if(input.dataset.mediaId)this.querySelector('vh-gallery')?.selectMedia(input.dataset.mediaId);
        if(!preview&&window.location.pathname.includes('/products/')){const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url)}
      },options);
      const initialChoice=this.querySelector('input[data-bundle-choice]:checked');
      const initialGift=this.querySelector('[data-included-gift]');
      if(initialGift&&initialChoice){initialGift.value=initialChoice.dataset.gift||'';initialGift.disabled=!initialChoice.dataset.gift}
      const initialAdd=this.querySelector('[data-add-button]'),initialStickyAdd=this.querySelector('[data-sticky-add]');
      if(initialAdd&&initialStickyAdd){initialStickyAdd.disabled=initialAdd.disabled;initialStickyAdd.textContent=initialAdd.firstChild.textContent}
      this.addEventListener('submit',event=>{
        if(!event.target.matches('.vh-product__form'))return;
        const selected=[...this.querySelectorAll('input[name="id"]')].find(input=>input.checked&&!input.disabled);
        if(this.dataset.launchEnabled!=='true'||!selected||!selected.value||selected.dataset.available!=='true'||selected.dataset.preview==='true')event.preventDefault();
      },options);
      const sticky=this.querySelector('[data-sticky-offer]'),offer=this.querySelector('.vh-product__form');
      if(sticky&&offer){this.observer=new IntersectionObserver(entries=>{const rect=entries[0].boundingClientRect;sticky.hidden=entries[0].isIntersecting||rect.top>0},{threshold:0});this.observer.observe(offer)}
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.controller=null}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vh-step-carousel')) {
    customElements.define('vh-step-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.track = this.querySelector('.vh-steps__track');
        this.slides = [...this.querySelectorAll('.vh-steps__slide')];
        this.previous = this.querySelector('[data-step-prev]');
        this.next = this.querySelector('[data-step-next]');
        this.counter = this.querySelector('[data-step-current]');
        this.index = 0;
        this.busy = false;
        this.media = window.matchMedia('(max-width: 749px)');
        this.setAttribute('data-enhanced', '');
        const controls = this.querySelector('.vh-steps__controls');
        if (controls) controls.hidden = false;
        this.previous?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('keydown', event => {
          if (!this.media.matches) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.track.addEventListener('pointerdown', event => {
          if (!this.media.matches || !event.isPrimary || event.button > 0 || this.busy) return;
          this.gesture = {id: event.pointerId, x: event.clientX, y: event.clientY, index: this.index, horizontal: false};
        }, options);
        this.track.addEventListener('pointermove', event => {
          const gesture = this.gesture;
          if (!gesture || event.pointerId !== gesture.id) return;
          const dx = event.clientX - gesture.x;
          const dy = event.clientY - gesture.y;
          if (!gesture.horizontal && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
            gesture.horizontal = true;
            this.track.setPointerCapture(event.pointerId);
          }
          if (!gesture.horizontal) return;
          event.preventDefault();
          const width = this.track.clientWidth;
          this.track.style.scrollSnapType = 'none';
          this.track.scrollLeft = gesture.index * width - Math.max(-width, Math.min(width, dx));
        }, options);
        const finishGesture = event => {
          const gesture = this.gesture;
          if (!gesture || event.pointerId !== gesture.id) return;
          this.gesture = null;
          this.track.style.scrollSnapType = '';
          const dx = event.clientX - gesture.x;
          const change = event.type !== 'pointercancel' && gesture.horizontal && Math.abs(dx) >= 35 ? (dx < 0 ? 1 : -1) : 0;
          this.goTo(gesture.index + change);
        };
        this.track.addEventListener('pointerup', finishGesture, options);
        this.track.addEventListener('pointercancel', finishGesture, options);
        this.track.addEventListener('wheel', event => {
          if (!this.media.matches || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
          event.preventDefault();
          const startsGesture = !this.wheelActive;
          this.wheelActive = true;
          clearTimeout(this.wheelTimer);
          this.wheelTimer = setTimeout(() => { this.wheelActive = false; }, 180);
          if (startsGesture && !this.busy) this.move(event.deltaX > 0 ? 1 : -1);
        }, {...options, passive: false});
        this.track.addEventListener('scroll', () => {
          if (!this.busy && !this.gesture) this.syncScroll();
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.syncScroll(), 150);
        }, options);
        this.track.addEventListener('scrollend', () => this.syncScroll(), options);
        this.resize = new ResizeObserver(() => this.goTo(this.index, true));
        this.resize.observe(this.track);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
          if (index !== -1) this.goTo(index, true);
        }, options);
        this.update();
      }
      move(direction) {
        if (!this.busy) this.goTo(this.index + direction);
      }
      syncScroll() {
        clearTimeout(this.scrollTimer);
        if (!this.media.matches || this.gesture) return;
        this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth))));
        this.busy = false;
        clearTimeout(this.timer);
        this.update();
      }
      goTo(index, instant = false) {
        this.index = Math.max(0, Math.min(this.slides.length - 1, index));
        clearTimeout(this.timer);
        clearTimeout(this.scrollTimer);
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.busy = !instant && !reduced;
        this.track.scrollTo({left: this.media.matches ? this.index * this.track.clientWidth : 0, behavior: instant || reduced ? 'auto' : 'smooth'});
        this.update();
        this.timer = setTimeout(() => { this.busy = false; }, 420);
      }
      update() {
        if (this.previous) this.previous.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === this.slides.length - 1;
        if (this.counter) this.counter.textContent = this.index + 1;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resize?.disconnect();
        clearTimeout(this.timer);
        clearTimeout(this.scrollTimer);
        clearTimeout(this.wheelTimer);
        this.gesture = null;
        this.wheelActive = false;
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-discover"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init=(root=document)=>{
  root.querySelectorAll('.vx-discover').forEach(section=>{
   if(section.dataset.vxReady) return;section.dataset.vxReady='true';
   const dialog=section.querySelector('[data-vx-zoom-dialog]'),viewport=dialog.querySelector('[data-vx-zoom-viewport]'),toggle=dialog.querySelector('[data-vx-zoom-toggle]'),trigger=section.querySelector('[data-vx-zoom]');
   trigger.addEventListener('click',()=>{viewport.dataset.zoomed='false';viewport.scrollTop=0;viewport.scrollLeft=0;toggle.setAttribute('aria-pressed','false');dialog.showModal();});
   toggle.addEventListener('click',()=>{const zoomed=viewport.dataset.zoomed!=='true';viewport.dataset.zoomed=String(zoomed);toggle.setAttribute('aria-pressed',String(zoomed));});
   dialog.querySelector('[data-vx-close]').addEventListener('click',()=>dialog.close());
   dialog.addEventListener('click',e=>{if(e.target!==dialog)return;const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();});
   dialog.addEventListener('close',()=>trigger.focus({preventScroll:true}));
  });
 };
 document.addEventListener('shopify:section:load',e=>init(e.target));
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-life"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init=(root=document)=>{
  const elements=root.querySelectorAll('.vx-scroll-reveal:not([data-vx-reveal])');
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('vx-in-view');observer.unobserve(e.target);}}),{threshold:.1});
  elements.forEach(e=>{e.dataset.vxReveal='true';e.classList.remove('vx-in-view');observer.observe(e);});
 };
 document.addEventListener('shopify:section:load',e=>init(e.target));
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-unfold"] && !Shopify.designMode) return;
  try {
    
(() => {
 const initialize=(root=document)=>{
  root.querySelectorAll('[data-vx-unfold]').forEach(section=>{
   if(section.dataset.unfoldReady) return;
   section.dataset.unfoldReady='true';
   const input=section.querySelector('[data-vx-unfold-range]'),stage=section.querySelector('[data-vx-fold-stage]'),object=section.querySelector('[data-vx-fold-object]'),cover=section.querySelector('[data-vx-fold-cover]'),panels=[...section.querySelectorAll('[data-vx-fold-panel]')],buttons=[...section.querySelectorAll('[data-vx-fold-value]')];
   function draw(){
    const value=Number(input.value),width=panels[0].offsetWidth,angle=(88-value*.88)*Math.PI/180,projected=width*Math.cos(angle),total=projected*panels.length,scale=Math.min(1,(stage.clientWidth-25)/(total+width)),start=(width*7-total-width)/2,opening=Math.min(1,value/25);
    object.style.transform=`translate(-50%,-50%) scale(${scale}) rotateX(9deg) rotateZ(-2deg)`;object.style.width=width*7+'px';
    panels.forEach((panel,i)=>{
     panel.style.transform=`translate3d(${start+width+i*projected}px,0,${i%2?width*Math.sin(angle):0}px) rotateY(${i%2?88-value*.88:-(88-value*.88)}deg)`;
     panel.style.filter=`brightness(${i%2?1-(100-value)/480:1})`;panel.style.opacity=value===0?'0':'1';
    });
    cover.style.transform=`translate3d(${width*3+(start-width*3)*opening}px,0,1px)`;cover.style.opacity='1';
    const nearest=value<25?0:value<75?1:2;
    buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===nearest)));
    section.querySelector('[data-vx-fold-status]').textContent=buttons[nearest].textContent;
    input.setAttribute('aria-valuetext',buttons[nearest].textContent);
   }
   input.addEventListener('input',draw);
   buttons.forEach(b=>b.addEventListener('click',()=>{input.value=b.dataset.vxFoldValue;draw();}));
   const observer=new ResizeObserver(draw);observer.observe(stage);draw();
   section.addEventListener('vx:destroy',()=>observer.disconnect(),{once:true});
  });
 };
 document.addEventListener('shopify:section:load',e=>initialize(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-vx-unfold]').forEach(s=>s.dispatchEvent(new Event('vx:destroy'))));
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-videos"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const initialize=(root=document)=>root.querySelectorAll('[data-vx-videos]').forEach(section=>{
  if(section.dataset.vxReady)return;section.dataset.vxReady='true';
  section.querySelectorAll('[data-vx-video-card]').forEach(card=>{
   const video=card.querySelector('video'),reduced=matchMedia('(prefers-reduced-motion: reduce)');
   video.muted=true;video.defaultMuted=true;video.loop=true;
   const sync=()=>{video.setAttribute('aria-pressed',String(!video.paused));video.setAttribute('aria-label',video.dataset.title+'. '+(video.paused?section.dataset.play:section.dataset.pause))};
   const play=()=>video.play().then(()=>{section.querySelector('.vx-video-error').hidden=true}).catch(()=>{sync();section.querySelector('.vx-video-error').hidden=false});
   let userPaused=false;video.playsInline=true;
   const toggle=()=>{userPaused=!video.paused;if(video.paused)play();else video.pause()};
   const resume=()=>{if(!userPaused&&!reduced.matches&&video.paused)play()};
   const visibility=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting)resume()})},{threshold:.25});visibility.observe(video);
   video.addEventListener('loadeddata',resume,{once:true});
   section.addEventListener('vx:cleanup',()=>visibility.disconnect(),{once:true});
   video.addEventListener('click',toggle);
   video.addEventListener('keydown',event=>{if(event.key===' '||event.key==='Enter'){event.preventDefault();toggle();}});
   video.addEventListener('play',sync);video.addEventListener('pause',sync);
   video.autoplay=!reduced.matches;
   if(reduced.matches)video.pause();else play();
   reduced.addEventListener('change',event=>{video.autoplay=!event.matches;if(event.matches)video.pause();else play();});
  });
  const viewport=section.querySelector('.vx-video-viewport');
  viewport.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();viewport.scrollBy({left:viewport.clientWidth*(e.key==='ArrowRight'?1:-1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})}});
 });
 document.addEventListener('shopify:section:load',e=>initialize(e.target));
 document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-vx-videos]').forEach(s=>{s.dispatchEvent(new Event('vx:cleanup'));s.querySelectorAll('video').forEach(v=>v.pause())}));
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
})();

  } catch(e) { console.error(e); }
})();
})();
